<div class="modal d-flex">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [hidden]="!chartTitle">{{chartTitle}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div mat-dialog-content>
          <div #svgContainer class="zoomedChart"></div>
        </div>
      </div>
    </div>
  </div>
</div>